var _a;
import { FormType } from './enums';
import { SubmissionRouteType } from '../../shared/models';
export var SystemRules = {
    madatoryFees: 'Mandatory_BrokerFees',
};
export var workflowConstants = (_a = {},
    _a[FormType.DIP] = {
        referred: 'DIP_REFERRED__WORKFLOW_TEXTS',
        successful: 'DIP_SUCCESSFUL__WORKFLOW_TEXTS',
        unsuccessful: 'DIP_UNSUCCESSFUL__WORKFLOW_TEXTS',
    },
    _a[FormType.Application] = {
        successful: 'APPLICATION_FORM_COMPLETED__WORKFLOW_TEXTS',
        readyToSubmit: 'APPLICATION_READY_TO_SUBMIT__WORKFLOW_TEXTS',
    },
    _a[FormType.Enquiry] = { successful: '[ENQUIRY-COMPLETED]__WORKFLOW_TEXTS' },
    _a[FormType.Illustration] = {
        successful: 'KFI_SUCCESSFUL__WORKFLOW_TEXTS',
        unsuccessful: 'KFI_UNSUCCESSFUL__WORKFLOW_TEXTS',
    },
    _a);
export var pageContentValues = {
    helpPage: {
        content: '[SALES-HELP-TEXT]__OTHER_TEXTS',
    },
    brokerAnnouncement: {
        content: 'Broker_Announcement_Text__OTHER_TEXTS',
    },
    fees: {
        nonMandatory: 'BROKER_FEE_NOT_MANDATORY',
    },
    clientDeletionText: {
        content: 'CLIENT_DELETION_VALIDATION_TEXT',
    },
    societyName: {
        content: '[SOCIETY-NAME]__SYST_SOC_DTLS',
    },
    lendindCriteria: {
        content: '[LENDING-CRITERIA]__OTHER_TEXTS',
    },
};
export var formTypeName = {
    illustration: 'Illustration',
    applicants: 'applicants',
    application: 'application',
    dip: 'dip',
    submit: 'submit',
    complete: 'complete',
};
export var directRouteValues = {
    id: 1000,
    displayText: 'Direct Application',
    value: SubmissionRouteType.DirectRoute + '_DirectRoute',
    type: SubmissionRouteType.DirectRoute,
    selectable: true,
};
export var mortgageDefaultValues = {
    id: 999,
    value: ' -- Mortgage Clubs -- ',
    type: SubmissionRouteType.None,
    selectable: false,
};
export var networkDefaultValues = {
    id: 998,
    value: '-- Networks --',
    type: SubmissionRouteType.None,
    selectable: false,
};
export var formStatusName = {
    passed: 'Passed',
    completed: 'Completed',
};
export var questionCodeName = {
    productCode: 'PRODCODE',
    addressCode: 'ADDRESS',
    purchasePrice: 'PURCHPRICE',
    loanAmount: 'LOANAMOUNT',
    loanTermYrs: 'LOANTERMYRS',
    loanTermMon: 'LO_MORTGAGETERMMON',
    amountPaid: 'ANNUITYAMT',
    interestPaid: 'INTONLYAMT',
};
export var questionDataType = {
    date: 'DATE',
    dateOfBirth: 'DATE OF BIRTH',
    address: 'ADDRESS',
    list: 'LIST',
    email: 'EMAIL',
    productByLTV: 'ProductByLTV',
    number: 'NUMBER',
    bool: 'BOOL',
    boolean: 'BOOLEAN',
    currency: 'CURRENCY',
    text: 'TEXT',
    string: 'STRING',
    percentage: 'PERCENTAGE', // Used for Case summary only.
};
export var answerCodeName = {
    purchasePrice: 'purchasePrice',
    loanAmount: 'loanAmount',
    mortgageTerm: 'mortgageTerm',
    loanTermMon: 'LO_MORTGAGETERMMON',
};
export var dialogText = {
    removeClientConfirmation: {
        title: '',
        description: 'Are you sure you want to remove this client?',
    },
    noIllustrationAvailable: {
        title: 'Continue without an illustration?',
        description: 'This product does not have an illustration available. You may still progress or return and select an alternate product.',
    },
    incompleteIllustration: {
        title: 'Something Went Wrong!',
        description: "We couldn't complete your illustration. Please review your illustration and resubmit. If you are still experiencing an issue, please get in touch with us.",
    },
    submitRecentESIS: {
        title: 'Submit Your Most Recent ESIS?',
        description: 'You will not be able to return to this stage, so make sure that the most recent illustration you have generated is the one you want to progress with.',
    },
};
export var AZURE_B2C_CANCEL_ERROR = 'AADB2C90091';
export var AZURE_B2C_BADREQUEST_ERROR = 'AADB2C90077';
export var header_MassageIfNoQuestionApplicantWise = 'This step may not be required for this applicant';
export var description_MassageIfNoQuestionApplicantWise = 'If you have completed all the previous steps and there are no questions showing then this step is not required';
export var loaderConstant = {
    isLoaderEnabled: 'IsLoaderEnabledOnBrokerUI',
    loaderProductId: 1,
    loadingText: 'Loading...',
};
